import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {isMobile} from 'react-device-detect';
import EpiContext from '@episerver/spa-core/Spa';
import {connect} from 'react-redux';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import Config from 'app/Config';
import {styledNumber} from 'app/utilities/StringHelpers/TitleHelpers';
import {refreshTokenAfterChangePhoneNumber} from '../changePhoneNumberSlice';

const SuccessPage = (props) => {
  return (
    <div className='general-message-page success-page step'>
      <div className='success-page-icon'>
        <Image src={require('../Icons/success.svg')} alt='v-icon' />
      </div>
      <div className='l-title'>המספר החדש הוחלף בהצלחה</div>
      <div className='new-number'>
        <div className='m-title mb-0'>זה המספר החדש שלך</div>{' '}
        <div className='primary-color fw-600' dangerouslySetInnerHTML={{__html: styledNumber(props.changePhoneNumber.newSelectedNumber)}} />
      </div>
      <div className='important-info'>
        <div className=''>
          <div className='fw-600'>איך ממשיכים?</div>
          <div className='important-info-text'>
            <div className='important-info-icon'>
              <Image src={require('../Icons/light.svg')} alt='light' />
            </div>
            <div>
              יש לכבות ולהדליק את המכשיר כדי
              <br /> שהמספר החדש יתעדכן
            </div>
          </div>
          <div className='important-info-text'>
            <div className='important-info-icon'>
              <Image src={require('../Icons/light.svg')} alt='light' />
            </div>
            <div>
              המספר החדש יופיע באזור האישי בעוד
              <br /> מספר דקות
            </div>
          </div>
        </div>
      </div>
      <div className='continue-button'>
        <BtnSubmit
          text={'סיום'}
          onclick={() => {
            props.refreshTokenAfterChangePhoneNumber();
            EpiContext.navigateTo(Config.lobbyUrl);
          }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  changePhoneNumber: state.changePhoneNumber,
});

const mapDispatchToProps = {refreshTokenAfterChangePhoneNumber};
export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
